module.exports = __webpack_public_path__ + "static/media/tooth2.7a06cb7a.svg";